import React from "react";
import ModuleList from "./list";

const Modules = () => {
  return <ModuleList />;
};

export default Modules;
